<template>
	<section class="section">
		<div class="container">
			<h1>About</h1>
		</div>
	</section>
</template>
